<template>
    <transition>
        <div class="change-rounds" v-if="roundIsChanging">
            <div class="modal">
                <p class="typingEffect" v-if="gameEnded == false">
                    {{langConfig[lang].round}} {{ round }}.
                </p>

                <p class="typingEffect" v-if="gameEnded">
                    {{langConfig[lang].the-end}}
                </p>
            </div>
        </div>
    </transition>
</template>

<script>
    import configLang from "../assets/config.json";

    export default {
        props: ["round", "timeToChangeRound", "lang"],
        data(){
            return {
                roundIsChanging: false,
                gameEnded: false,
                langConfig: configLang,       
            }
        },
        watch: {
            round(newValue, oldValue){
                this.roundIsChanging = true;

                if(newValue == 1 && oldValue > newValue){
                    this.gameEnded = true;
                }

                setTimeout(() => {
                    this.roundIsChanging = false;
                    this.gameEnded = false;
                }, this.timeToChangeRound);
            }
        }
    }
</script>

<style lang="scss" scoped>

.change-rounds{
    background: rgba(0, 0, 0, 0.79);
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    z-index: 10;

    display: flex;
    align-items: center;
    justify-content: center;
    
    .modal{
        // background: #fff;
        color: #fff;
        padding: 20px 30px;
        border-radius: 20px;
        font-size: 45px;
        font-weight: 800;
    }
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.typingEffect {
    width: 0;
    overflow: hidden;
    border-right: 2px solid white;
    white-space: nowrap;
    animation: typing 3s forwards;
}

/* The typing animation */
@keyframes typing {
    0% { width: 0 }
    40% { width: 100% }
    60% { width: 100% }
    100% { width: 0 }
}

</style>